module.exports = __webpack_public_path__ + "static/media/8_portrait.6fc5d120.jpg";